import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Button, errorCrossIcon } from '@treezor/design-system';

const Subtitle = styled.span`
  font-weight: ${(props) => props.theme.typography?.fontWeightRegular};
  color: ${(props) => props.theme.palette.subtext};
  font-style: normal;
  font-size: 1.2rem;
  line-height: 1.45rem;
  margin-bottom: 1rem;
  text-align: center;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 25rem;
  margin: 10rem auto;
`;

interface ITemplatesError {
  message: string;
  onReload: () => void;
}

export const TemplatesError = ({ message, onReload }: ITemplatesError) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <img className="h-[4rem]" src={errorCrossIcon} />
      <span className="typo-h6-bold text-secondary mt-6">{t('pages.cores.error')}</span>
      <Subtitle>{message}</Subtitle>
      <span className="typo-body-regular-paragraphLarge text-tertiary mb-4 ">{message}</span>
      <Button type="button" id="templates-reload-btn" color="default" onClick={onReload}>
        {t('pages.administration.templates.reload')}
      </Button>
    </Wrapper>
  );
};
